import { NavLink, Outlet, useNavigate } from "react-router-dom";

const navItems = [
  { label: "总览", path: "/admin" },
  { label: "用户管理", path: "/admin/users" },
  { label: "咨询师管理", path: "/admin/consultants" },
  { label: "系统消息", path: "/admin/messages" },
  { label: "机构管理", path: "/admin/organizations" },
  { label: "网站管理", path: "/admin/site" },
  { label: "平台规则", path: "/admin/platform-settings" },
  { label: "AI测评题目", path: "/admin/questionnaire" },
  { label: "读书会管理", path: "/admin/book-club" },
  { label: "关系成长", path: "/admin/growth" },
  { label: "收录记录", path: "/admin/seo-log" },
  { label: "活动发布", path: "/admin/events" },
  { label: "视频课程", path: "/admin/courses" },
  { label: "电子书管理", path: "/admin/ebooks" },
  { label: "会员动态", path: "/admin/moments" },
  { label: "访问统计", path: "/admin/analytics" },
  { label: "领证地点", path: "/admin/marriage-places" },
  { label: "生活好物商城", path: "/admin/shop" },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const adminToken = localStorage.getItem("admin_token");

  if (!adminToken) {
    navigate("/admin/login");
    return null;
  }

  const logout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_name");
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <aside className="w-64 bg-gray-900 text-white flex flex-col">
        <div className="p-6 border-b border-white/10">
          <h1 className="text-xl font-bold">网站总后台</h1>
          <p className="text-sm text-gray-400 mt-1">运营管理中心</p>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === "/admin"}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-sm font-medium ${
                  isActive
                    ? "bg-blue-600 text-white"
                    : "text-gray-300 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={logout}
            className="w-full py-3 rounded-xl bg-white/10 hover:bg-white/15 text-sm font-bold"
          >
            退出登录
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        <header className="h-16 bg-white border-b px-8 flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-400">Admin</p>
            <p className="font-bold text-gray-800">
              {localStorage.getItem("admin_name") || "管理员"}
            </p>
          </div>
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-xl bg-pink-50 text-pink-600 text-sm font-medium hover:bg-pink-100"
          >
            打开首页
          </a>
        </header>

        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}